/* eslint-disable react/no-danger */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-param-reassign */
/* eslint-disable prettier/prettier */
import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ReactTooltip from "react-tooltip";
import { Hidden } from "@mui/material";
import { Board } from "../../data/Board";
import { renderTextWithLineBreaks } from '../../Constants/utils'
import { centerContent } from "../../Constants/styles";
import {
  PlayerEclipse,
  BLGate,
  BRGate,
  TLGate,
  TRGate,
  ConstraintInnerCircle,
  ConstraintOuterCircle,
  ConstraintTriangle,
  GateOuterCircle,
  MilestoneInnerCircle,
  MilestoneOuterCircle,
  MilestoneKite,
  PlannedTaskInnerCircle,
  PlannedTaskOuterCircle,
  RiskInnerCircle,
  RiskOuterCircle,
  RiskPoligon,
  UnplannedInnerCircle,
  UnplannedOuterCircle,
  StartTileInner,
  StartTileOuter,
  FinishTileOuter,
  FinishTileInner,
  Info,
  DiamondSm,
} from "../../Constants/assets";
import { getFullNameAbbreviation, progressAnimationCoords } from "../../utils/global";




/* FIXME: This component is almost exactly as the UnplannedTaskWrapper
   and RiskWrapper and other components component, there must be a way
   to write that as a single component */
const NameTag = styled.div.attrs({
  "data-progress": "1",
})`
  position: absolute;
  top: -33px;
  right: 5.3rem;
  z-index: 1;
  display: grid;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: ${(props) => props.theme.colors.white};
  height: 65px;
  width: max-content;
  text-align: center;
  align-content: center;
  justify-items: center;

`;
const PlayerIdentity = styled.div`
  background-color: ${(props) => props.theme.colors.purple};
  border-radius: 4px;
  width: fit-content;
  height: fit-content;
  padding: 2px 8px;
  margin-bottom: 3px;
  font-size: 15px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.white};
`;

const PlannedTaskWrapper = styled.div`
  ${centerContent}
  position: absolute;
  width: 80px;
  height: 80px;
  cursor: pointer;
`;

/* FIXME: This component is almost exactly as the UnplannedTaskInner and
   RiskInner and other components component, there must be a way to write
   that as a single component */
const PlannedTaskInner = styled.div`
  ${centerContent}
  position: relative;
  width: 64px;
  height: 64px;
`;
const Number = styled.div`
  text-align: center;
  vertical-align: middle;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
`;
const UnplannedTaskWrapper = styled.div`
  ${centerContent}
  position: absolute;
  width: 80px;
  height: 80px;
  cursor: pointer;
`;
const UnplannedTaskInner = styled.div`
  ${centerContent}
  position: relative;
  width: 64px;
  height: 64px;
`;
const NumberWhite = styled.div`
  text-align: center;
  vertical-align: middle;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: ${(props) => props.theme.colors.white};
`;
const RiskWrapper = styled.div`
  ${centerContent}
  position: absolute;
  width: 80px;
  height: 80px;
  border-radius: 40px;
  border: 6px solid ${(props) => props.theme.colors.red};
  background-color: ${(props) => props.theme.colors.white};
  cursor: pointer;
`;
const RiskInner = styled.div`
  ${centerContent}
  position: relative;
  width: 64px;
  height: 64px;
  border-radius: 32px;
  border: 2px solid ${(props) => props.theme.colors.red};
`;
const Hexagon = styled.div`
  width: 48px;
  height: 25px;
  background-color: ${(props) => props.theme.colors.red};
  border-color: ${(props) => props.theme.colors.red};
  position: relative;
  display: inline-block;
  &:before {
    content: "";
    width: 0;
    height: 0;
    border-bottom: 17px solid;
    border-color: inherit;
    border-left: 24px solid transparent;
    border-right: 24px solid transparent;
    position: absolute;
    top: -17px;
  }
  &:after {
    content: "";
    width: 0;
    position: absolute;
    bottom: -18px;
    border-top: 18px solid;
    border-color: inherit;
    border-left: 24px solid transparent;
    border-right: 24px solid transparent;
  }
`;
const MileStoneWrapper = styled.div`
  ${centerContent}
  position: absolute;
  width: 80px;
  height: 80px;
  border-radius: 40px;
  border: 6px solid ${(props) => props.theme.colors.black};
  background-color: ${(props) => props.theme.colors.white};
  cursor: pointer;
`;
const MileStoneInner = styled.div`
  ${centerContent}
  position: relative;
  width: 64px;
  height: 64px;
  border-radius: 32px;
  border: 2px solid ${(props) => props.theme.colors.black};
`;
const Rhombus = styled.div`
  height: 0;
  width: 0;
  border: 24px solid transparent;
  border-bottom-color: ${(props) => props.theme.colors.black};
  position: relative;
  top: -24px;
  &:before {
    content: "";
    position: absolute;
    left: -24px;
    top: 24px;
    width: 0;
    height: 0;
    border: 24px solid transparent;
    border-top-color: ${(props) => props.theme.colors.black};
  }
`;
const InnerRhombus = styled.div`
  ${centerContent}

  height: 46px;
  border-radius: 32px;
`;
const NumberRhombus = styled.div`
  text-align: center;
  vertical-align: middle;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: ${(props) => props.theme.colors.white};
  z-index: 1;
`;
const ConstraintWrapper = styled.div`
  ${centerContent}
  position: absolute;
  width: 80px;
  height: 80px;
  border-radius: 40px;
  border: 6px solid ${(props) => props.theme.colors.orange};
  background-color: ${(props) => props.theme.colors.white};
  cursor: pointer;
`;
const ConstraintInner = styled.div`
  ${centerContent}
  position: relative;
  width: 64px;
  height: 64px;
  border-radius: 32px;
  border: 2px solid ${(props) => props.theme.colors.orange};
`;
const Triangle = styled.div`
  width: 40px;
  height: 0px;
  border-top: solid 40px transparent;
  border-left: solid 24px transparent;
  border-right: solid 24px transparent;
  position: relative;
  top: 4px;
  left: 2px;
`;
const NumberTriangle = styled.div`
  text-align: center;
  vertical-align: middle;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: ${(props) => props.theme.colors.white};
  position: relative;
  top: -38px;
  ${({ number }) => (number < 10 ? `left: -7px;` : `left:-13px`)}
`;
const GateWrapper = styled.div`
  ${centerContent}
  position: absolute;
  width: 80px;
  height: 80px;
  cursor: pointer;
`;
const GateInner = styled.div`
  width: 64px;
  height: 64px;
  position: relative;
  margin: 0 auto;
`;

/* FIXME: All of the quarters are built the same except for the background and border-radius
   you can write that as one component with some functionality for determining the background
   and border radius */

const NumberGate = styled.div`
  text-align: center;
  vertical-align: middle;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: ${(props) => props.theme.colors.white};
  height: 50%;
  width: 50%;
  position: absolute;
  top: 22%;
  left: 25%;
`;

const ContinuePlayingBtn = styled.div`
  text-align: center;
  text-decoration-line: underline;
  color: ${(props) => props.theme.colors.black};
  font-size: 15px;
  max-width:5.6vw;
  margin-bottom:64px;
`;
const OpenButton = styled.button`
  border-radius: 50%;
`;

const ButtonNumber = styled.div`
  font-weight: 700;
  fonst-size: 26px;
`;
const TolTipContainer = styled.div``;
const SvgWrapper = styled.div`
  position: absolute;
  left: -10px;
  top: -10px;
`;
const MileStoneTolTipPopUp = styled.div`
  padding: 2px 2px 2px 2px;
  position: absolute;
  bottom: 20px;
  left: -25px;
  z-index: 99;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: inset 0px 0px 7px rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(4px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 6px;
`;
const GateTolTipPopUp = styled.div`
  padding: 5px;
  position: absolute;
  top: -20px;
  left: 30px;
  z-index: 99;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: inset 0px 0px 7px rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(4px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 6px;
`;
const CaretBottom = styled.div`
  position: absolute;
  bottom: -10px;
  left: 10px;
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 15px solid rgba(255, 255, 255, 0.8);
`;
const CaretLeft = styled.div`
  position: absolute;
  top: 10px;
  left: -15px;
  width: 0;
  height: 0;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-right: 15px solid rgba(255, 255, 255, 0.8);
`;

function Player(
  tileNumber,
  playerLocation,
  name,
  isPaused,
  showIsPaused,
  setNewTurn,
  isExpendedMap,
  startTurn,
  currentTileType,
  toggleExecuteGPMTOnMilestone,
  executeGPMTOnMilestone,
  checkedTask,
  taskToggle,
  toggleProject,
  showOpenProjectSheetAfterBack
) {
  const { t } = useTranslation();
  const shouldShowOpenProjectSheetLink =
    !taskToggle &&
    currentTileType === 'planned-task' &&
    !Board[playerLocation]?.executed &&
    showOpenProjectSheetAfterBack;

  if (tileNumber === playerLocation) {
    const playerDisplayName = name && name.trim().length ? name : "";
    const playerInitials = playerDisplayName
      ? getFullNameAbbreviation(playerDisplayName)
      : "";
    return (
      <>
        <PlayerEclipse
          className="Player"
          data-progress={1}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "-18px",
            left: "-29px",
          }}
        />
        <NameTag className="Player">
          <PlayerIdentity>{playerInitials}</PlayerIdentity>
          {shouldShowOpenProjectSheetLink ? (
            <ContinuePlayingBtn
              style={{ marginBottom: '10px' }}
              onClick={() => {
                toggleProject(0);
              }}
            >
              {renderTextWithLineBreaks(t('sidebar.project_sheet_link'))}
            </ContinuePlayingBtn>
          ) : (
            <>
              {showIsPaused && !isExpendedMap && (
                <ContinuePlayingBtn
                  onClick={() => {
                    if (currentTileType == "mile-stone" && executeGPMTOnMilestone) {
                      toggleExecuteGPMTOnMilestone(false);
                    }
                    isPaused(false);
                    setNewTurn(false);
                    startTurn();
                  }}
                >
                  {renderTextWithLineBreaks(t('global_variables.new_turn_link'))}
                </ContinuePlayingBtn>
              )}
              {currentTileType == "mile-stone" && executeGPMTOnMilestone && (!(showIsPaused && !isExpendedMap)) && (
                <ContinuePlayingBtn
                  onClick={() => {
                    toggleExecuteGPMTOnMilestone(false);
                    setNewTurn(false);
                    startTurn();
                  }}
                >
                  {renderTextWithLineBreaks(t('global_variables.new_turn_link'))}
                </ContinuePlayingBtn>
              )}
            </>
          )}
        </NameTag>
      </>
    );
  }
}
function OpenGeneralTaskObject(
  tileNumber,
  playerLocation,
  toggle,
  projectStage,
  SoundPlay,
  toggleProjectSound,
  ProjectScopeDisable,
  toggleDisableScreen,
) {
  if (tileNumber === playerLocation) {
    return (
      <>
        <OpenButton
          onClick={() => {
            toggle(projectStage);
            ProjectScopeDisable(false);
            toggleDisableScreen(false);
          }}
          className="Player"
          data-progress={1}
          style={{
            position: "absolute",
            width: "63%",
            height: "63%",
            top: "18%",
            left: "19%",
            backgroundColor: "transparent",
            border: "none",
            cursor: "pointer",
          }}
        >
          <Number />
        </OpenButton>
      </>
    );
  }
}

export default function Tile({
  number = 0,
  toggleProject,
  openStage,
  type = "constraint",
  player = 0,
  playerName = "Maya Avraham",
  top = "10%",
  left = "10%",
  handleProgress,
  isPaused,
  currentLanguage,
  setNewTurn,
  showIsPaused = { showIsPaused },
  SoundPlay,
  toggleProjectSound,
  isExpendedMap,
  startTurn,
  currentTileType,
  toggleExecuteGPMTOnMilestone,
  executeGPMTOnMilestone,
  ProjectScopeDisable,
  toggleDisableScreen,
  checkedTask,
  taskToggle,
  ExecuteTaskPopUpShow,
  showOpenProjectSheetAfterBack = false,
}) {
  const [visibleMS, setVisibleMS] = useState("hidden");
  const [visibleG, setVisibleG] = useState("hidden");
  const thatPopUpIdMileStone = `mileStonePopUp_${Board[number].id}`;
  const thatPopUpIdGate = `gatePopUp_${Board[number].id}`;
  const numberRef = useRef(null);
  const [fontSize, setFontSize] = useState('19px');
  useEffect(() => {
    const updateFontSize = () => {
      if (numberRef.current) {
        const width = numberRef.current.offsetWidth;
        console.log('Width:', width); // Log the width
        setFontSize(width > 64 ? '15px' : '19px');
      }
    };

    // Run on component mount
    updateFontSize();

    // Optional: Handle dynamic resizing
    window.addEventListener('resize', updateFontSize);

    // Clean up the event listener
    return () => {
      window.removeEventListener('resize', updateFontSize);
    };
  }, [currentLanguage]);

  const { t } = useTranslation();
  switch (type) {
    default:
    case "start":
      return (
        <PlannedTaskWrapper
          style={{
            top,
            left,
          }}
        >
          <StartTileOuter style={{ position: "absolute" }} />
          <StartTileInner style={{ position: "absolute" }} />
          <PlannedTaskInner>
            <Number
              ref={numberRef}
              style={{
                color: "#005857",
                fontSize
              }}
            >
              {t('global_variables.start')}
            </Number>
          </PlannedTaskInner>
          {Player(
            number,
            player,
            playerName,
            isPaused,
            showIsPaused,
            setNewTurn,
            isExpendedMap,
            startTurn,
            currentTileType,
            toggleExecuteGPMTOnMilestone,
            executeGPMTOnMilestone,
            checkedTask,
            taskToggle,
            toggleProject,
            showOpenProjectSheetAfterBack
          )}
        </PlannedTaskWrapper>
      );
    case "finish":
      return (
        <PlannedTaskWrapper
          style={{
            top,
            left,
          }}
        >
          <FinishTileOuter style={{ position: "absolute" }} />
          <FinishTileInner style={{ position: "absolute" }} />
          <PlannedTaskInner>
            <Number
              style={{
                color: "#9E459A",
                fontSize: "17px",
              }}
            >
              {t('global_variables.finish')}
            </Number>
          </PlannedTaskInner>
          {Player(
            number,
            player,
            playerName,
            isPaused,
            showIsPaused,
            setNewTurn,
            isExpendedMap,
            startTurn,
            currentTileType,
            toggleExecuteGPMTOnMilestone,
            executeGPMTOnMilestone,
            checkedTask,
            taskToggle,
            toggleProject,
            showOpenProjectSheetAfterBack
          )}
        </PlannedTaskWrapper>
      );
    case "planned-task":
      return (
        <PlannedTaskWrapper
          style={{
            top,
            left,
          }}
        >
          <PlannedTaskOuterCircle style={{ position: "absolute" }} />
          <PlannedTaskInnerCircle style={{ position: "absolute" }} />
          <PlannedTaskInner>
            <Number> {number} </Number>
          </PlannedTaskInner>
          {Player(
            number,
            player,
            playerName,
            isPaused,
            showIsPaused,
            setNewTurn,
            isExpendedMap,
            startTurn,
            currentTileType,
            toggleExecuteGPMTOnMilestone,
            executeGPMTOnMilestone,
            checkedTask,
            taskToggle,
            toggleProject,
            showOpenProjectSheetAfterBack
          )}
          {OpenGeneralTaskObject(
            number,
            player,
            toggleProject,
            openStage,
            SoundPlay,
            toggleProjectSound,
            ProjectScopeDisable,
            toggleDisableScreen,
          )}
        </PlannedTaskWrapper>
      );
    case "unplanned-task":
      return (
        <UnplannedTaskWrapper
          style={{
            top,
            left,
          }}
        >
          <UnplannedOuterCircle style={{ position: "absolute" }} />
          <UnplannedInnerCircle style={{ position: "absolute" }} />
          <UnplannedTaskInner>
            <NumberWhite> {number} </NumberWhite>
            {Player(
              number,
              player,
              playerName,
              isPaused,
              showIsPaused,
              setNewTurn,
            isExpendedMap,
            startTurn,
            currentTileType,
            toggleExecuteGPMTOnMilestone,
            executeGPMTOnMilestone,
            checkedTask,
            taskToggle,
            toggleProject,
            showOpenProjectSheetAfterBack
          )}
          </UnplannedTaskInner>
        </UnplannedTaskWrapper>
      );
    case "Risk":
      return (
        <RiskWrapper
          style={{
            top,
            left,
          }}
        >
          <RiskOuterCircle style={{ position: "absolute" }} />
          <RiskInnerCircle style={{ position: "absolute" }} />
          <RiskPoligon style={{ position: "absolute" }} />
          <RiskInner>
            <NumberWhite> {number} </NumberWhite>
          </RiskInner>
          {Player(
            number,
            player,
            playerName,
            isPaused,
            showIsPaused,
            setNewTurn,
            isExpendedMap,
            startTurn,
            currentTileType,
            toggleExecuteGPMTOnMilestone,
            executeGPMTOnMilestone,
            checkedTask,
            taskToggle,
            toggleProject,
            showOpenProjectSheetAfterBack
          )}
        </RiskWrapper>
      );
    case "mile-stone":
      return (
        <MileStoneWrapper
          style={{
            top,
            left,
          }}
        >
          <MilestoneOuterCircle style={{ position: "absolute" }} />
          <MilestoneInnerCircle style={{ position: "absolute" }} />
          <TolTipContainer
            onMouseOver={() => {
              setVisibleMS("visible");
            }}
            onMouseLeave={() => {
              setVisibleMS("hidden");
            }}
            style={{
              position: "absolute",
              marginBottom: number % 8 == 2 || number % 8 == 6 ? "115px" : "0",
              marginLeft:
                number % 8 == 5 || number % 8 == 4 || number % 8 == 3
                  ? "115px"
                  : "0",
              marginRight:
                number % 8 == 7 || number % 8 == 1 || number % 8 == 0
                  ? "115px"
                  : "0",
            }}
          >
            <MileStoneTolTipPopUp
              style={{
                visibility: visibleMS,
                width: "max-content",
                height: "80px",
              }}
              data-tile_id={Board[number].id}
            >
              {t('tooltip.milestone')}
              <br />
              {t('global_variables.budget')}: ${Board[number].milestone.resources.budget} <br />
              {t('global_variables.resources.resources')}: {
                Board[number].milestone.resources.standard
              }  {t('global_variables.resources.standard')}, {Board[number].milestone.resources.senior}  {t('global_variables.resources.senior')} {t('global_variables.and')}{" "}
              {Board[number].milestone.resources.expensive}  {t('global_variables.resources.executive')}
              <CaretBottom />
            </MileStoneTolTipPopUp>
            <SvgWrapper data-tip data-for={thatPopUpIdMileStone}>
              <Info
                style={{
                  height: "23px",
                  width: "23px",
                }}
              />
            </SvgWrapper>
          </TolTipContainer>
          <MilestoneKite style={{ position: "absolute" }} />
          <MileStoneInner>
            <Rhombus>
              <InnerRhombus>
                <NumberRhombus> {number} </NumberRhombus>
              </InnerRhombus>
            </Rhombus>
          </MileStoneInner>
          {Player(
            number,
            player,
            playerName,
            isPaused,
            showIsPaused,
            setNewTurn,
            isExpendedMap,
            startTurn,
            currentTileType,
            toggleExecuteGPMTOnMilestone,
            executeGPMTOnMilestone,
            checkedTask,
            taskToggle,
            toggleProject,
            showOpenProjectSheetAfterBack
          )}
        </MileStoneWrapper>
      );
    case "Constraint":
      return (
        <ConstraintWrapper
          style={{
            top,
            left,
          }}
        >
          <ConstraintOuterCircle style={{ position: "absolute" }} />
          <ConstraintInnerCircle style={{ position: "absolute" }} />
          <ConstraintTriangle style={{ position: "absolute", top: "18px" }} />
          <ConstraintInner>
            <Triangle>
              <NumberTriangle number={number}> {number} </NumberTriangle>
            </Triangle>
          </ConstraintInner>
          {Player(
            number,
            player,
            playerName,
            isPaused,
            showIsPaused,
            setNewTurn,
            isExpendedMap,
            startTurn,
            currentTileType,
            toggleExecuteGPMTOnMilestone,
            executeGPMTOnMilestone,
            checkedTask,
            taskToggle,
            toggleProject,
            showOpenProjectSheetAfterBack
          )}
        </ConstraintWrapper>
      );
    case "gate":
      return (
        <GateWrapper
          style={{
            top,
            left,
          }}
        >
          <GateOuterCircle style={{ position: "absolute" }} />
          <TolTipContainer
            onMouseOver={() => {
              setVisibleG("visible");
            }}
            onMouseLeave={() => {
              setVisibleG("hidden");
            }}
            style={{
              position: "absolute",
              marginBottom: number % 8 == 2 || number % 8 == 6 ? "115px" : "0",
              marginLeft:
                number % 8 == 5 || number % 8 == 4 || number % 8 == 3
                  ? "115px"
                  : "0",
              marginRight:
                number % 8 == 7 || number % 8 == 1 || number % 8 == 0
                  ? "115px"
                  : "0",
            }}
          >
            <GateTolTipPopUp
              style={{
                visibility: visibleG,
                width: "max-content",
                height: "max-content",
              }}
            >
              {t('tooltip.gate1')}
              <br />
              {t('global_variables.budget')}: ${Board[number].gate.resources.budget}
              <br />
              {t('global_variables.resources.resources')}: {Board[number].gate.resources.standard} {t('global_variables.resources.standard')},{" "}
              {Board[number].gate.resources.senior} {t('global_variables.resources.senior')} {t('global_variables.and')}{" "}
              {Board[number].gate.resources.expensive} {t('global_variables.resources.executive')} <br />
              <br />
              <span dangerouslySetInnerHTML={{ __html: t('tooltip.gate2').replace(/\n/g, '<br/>') }}></span>
              <br />
              {"<"} <DiamondSm />
              {Board[number].gate.rates.low} {t('modals.gate_control.cancel_project.info_title2')}
              <br />
              {"<"} <DiamondSm />
              {Board[number].gate.rates.medium} {t('modals.gate_control.go_back.info_title2')}
              <br />
              {"<"} <DiamondSm />
              {Board[number].gate.rates.high} {t('modals.gate_control.delay.info_title2')}
              <br />
              {">="} <DiamondSm />
              {Board[number].gate.rates.high} {t('modals.gate_control.go_forward.info_title2')}
              <br />
              <CaretLeft />
            </GateTolTipPopUp>
            <SvgWrapper data-tip data-for={thatPopUpIdGate}>
              <Info
                style={{
                  height: "23px",
                  width: "23px",
                }}
              />
              {/* <ReactTooltip id={thatPopUpIdGate} place="top" type='light' effect='solid' > */}

              {/* </ReactTooltip> */}
            </SvgWrapper>
          </TolTipContainer>
          <GateInner>
            <TLGate
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                width: "50%",
                height: "50%",
              }}
            />
            <TRGate
              style={{
                position: "absolute",
                top: "0",
                left: "50%",
                width: "50%",
                height: "50%",
              }}
            />
            <BLGate
              style={{
                position: "absolute",
                top: "50%",
                left: "0",
                width: "50%",
                height: "50%",
              }}
            />
            <BRGate
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                width: "50%",
                height: "50%",
              }}
            />
            <NumberGate> {number} </NumberGate>
          </GateInner>
          {Player(
            number,
            player,
            playerName,
            isPaused,
            showIsPaused,
            setNewTurn,
            isExpendedMap,
            startTurn,
            currentTileType,
            toggleExecuteGPMTOnMilestone,
            executeGPMTOnMilestone,
            checkedTask,
            taskToggle,
            toggleProject,
            showOpenProjectSheetAfterBack
          )}
        </GateWrapper>
      );
  }
}
